<script lang="ts" setup>
	import type { ClassNameValue } from 'tailwind-merge'
	import type { FormRecordsContext, FormRecordsContexts } from '@/composables/useFormsFields'

	defineProps<{
		items: FormRecordsContexts
		itemCls?: ClassNameValue
		inputCls?: ClassNameValue
		tag?: string
	}>()
	const form = defineModel<Record<string, unknown>>({ required: true })
	defineEmits<{
		(e: 'change', value: unknown): void
	}>()
	const cls = computed(() => String(useAttrs().class))
	defineOptions({
		inheritAttrs: false
	})
	const filterKey = (item: FormRecordsContext) => {
		const { hidden, ...rest } = item
		return rest
	}
</script>

<template>
	<component :is="tag || 'div'" :class="cls">
		<template v-for="(item, index) in items" :key="item?.form_name || `form-item-${String(index)}`">
			<template v-if="item && !item?.hidden">
				<li v-if="tag === 'ul'" :class="cn(itemCls, item?.itemClass)">
					<form-kit-field
						v-bind="filterKey(item)"
						v-model:value="form[item.form_name]"
						:state-value="form?.state as string"
						:lga-value="form?.lga as string"
						:wrapper-class="[item?.wrapperClass, itemCls]"
						:input-class="[inputCls, item.inputClass]"
						@change="
							payload => {
								if (item.type === 'local-user-state' && payload && typeof payload === 'object') {
									form.state = (payload as Record<string, unknown>).state
									form.lga = (payload as Record<string, unknown>).lga
								}
								$emit('change', payload)
							}
						"
					>
						<template #[item.form_name]>
							<slot :name="item.form_name" v-bind="item"> </slot>
						</template>
						<template v-if="$slots.label" #label="scope">
							<slot name="label" v-bind="scope" />
						</template>
					</form-kit-field>
				</li>
				<template v-else>
					<slot v-bind="item">
						<form-kit-field
							v-bind="filterKey(item)"
							v-model:value="form[item.form_name]"
							:state-value="form?.state as string"
							:lga-value="form?.lga as string"
							:wrapper-class="[item?.wrapperClass, itemCls]"
							:input-class="[inputCls, item.inputClass]"
							@change="
								payload => {
									if (item.type === 'local-user-state' && payload && typeof payload === 'object') {
										form.state = (payload as Record<string, unknown>).state
										form.lga = (payload as Record<string, unknown>).lga
									}
									$emit('change', payload)
								}
							"
						>
							<template v-if="$slots.label" #label="scope">
								<slot name="label" v-bind="scope" />
							</template>
							<template #[item.form_name]>
								<slot :name="item.form_name" v-bind="item"> </slot>
							</template>
						</form-kit-field>
					</slot>
				</template>
			</template>
		</template>
	</component>
</template>
